import {
    LIST_MARKER_DICT,
    LIST_STYLE_SPACE,
    LIST_STYLE_SPACE_MAX,
    TextWritingType,
    type BaseTextInfo,
} from '@/version-types';

/**
 * 获取列表字符
 *
 * @param listStyle - 列表样式
 * @param order - 列表序号
 * @param options - 选项
 *  - padZero - 是否需要补零
 *  - followDot - 是否需要跟随点号
 * @returns 列表序号字符
 */
export const getListMarkerChars = (
    listStyle: string,
    order: number,
    options?: { padZero?: boolean; followDot?: boolean },
) => {
    const { padZero = false, followDot = true } = options || {};
    const trailing = followDot ? '.' : '';

    if (listStyle === 'decimal') {
        if (!padZero) return `${order}` + trailing;

        return order < 10 ? `0${order}` + trailing : `${order}` + trailing;
    }

    if (listStyle === 'disc' || listStyle === 'circle' || listStyle === 'square') {
        return LIST_MARKER_DICT[listStyle] + trailing;
    }

    const serialNumbers = LIST_MARKER_DICT[listStyle];
    const idx = order % serialNumbers.length;

    return serialNumbers[idx - 1 >= 0 ? idx - 1 : serialNumbers.length - 1] + trailing;
};

/**
 * 当列表文本场景下，是否需要保留更多的 list padding
 *
 * @param data - 文本信息
 */
export const getListTextPreservePadding = (data: BaseTextInfo) => {
    const { listStyle, listStyleMaterial, text, writingMode, fontSize } = data;
    if (!listStyle) {
        return {
            paddingLeft: 0,
            paddingTop: 0,
        };
    }

    let paddingLeft = 0;
    let paddingTop = 0;

    if (listStyleMaterial) {
        const iconWidth = listStyleMaterial.iconWidth;
        const baseFontSize = listStyleMaterial.baseContentTextSize;
        const ratio = fontSize / baseFontSize;
        const width = iconWidth * ratio * listStyleMaterial.scale;
        const distance = Math.min(18 * ratio, 18); // 需要距离列表内容 18px

        if (writingMode === TextWritingType.HORIZONTAL_TB) {
            paddingLeft = width + distance;
        } else {
            paddingTop = width + distance;
        }
    } else {
        const count = text.split('\n').length;

        const more =
            (listStyle === 'decimal' && count >= 10) ||
            (listStyle === 'lower-latin' && count >= 13) ||
            (listStyle === 'upper-roman' && count >= 3);

        const factor = more ? LIST_STYLE_SPACE_MAX : LIST_STYLE_SPACE;

        if (writingMode === TextWritingType.HORIZONTAL_TB) {
            paddingLeft = factor * fontSize;
        } else {
            paddingTop = factor * fontSize;
        }
    }

    return {
        paddingLeft,
        paddingTop,
    };
};
